export default "__VITE_ASSET__CLkA6x_u__"